import { StormBuildUpRowDef } from './stormBuildUpTypes';

export const HEADWALL_ROWS: StormBuildUpRowDef[] = [
  { id: 'hw_hdr', description: 'HEADWALLS', unit: '', defaultQuant: null, isHeader: true },
  { id: 'hw_225', description: 'Headwall to suit 225mmØ pipe', unit: 'Nr', defaultQuant: null },
  { id: 'hw_300', description: 'Headwall to suit 300mmØ pipe', unit: 'Nr', defaultQuant: null },
  { id: 'hw_375', description: 'Headwall to suit 375mmØ pipe', unit: 'Nr', defaultQuant: null },
  { id: 'hw_450', description: 'Headwall to suit 450mmØ pipe', unit: 'Nr', defaultQuant: null },
  { id: 'hw_525', description: 'Headwall to suit 525mmØ pipe', unit: 'Nr', defaultQuant: null },
  { id: 'hw_600', description: 'Headwall to suit 600mmØ pipe', unit: 'Nr', defaultQuant: null },
  { id: 'hw_750', description: 'Headwall to suit 750mmØ pipe', unit: 'Nr', defaultQuant: null },
  { id: 'hw_900', description: 'Headwall to suit 900mmØ pipe', unit: 'Nr', defaultQuant: null },
  { id: 'hw_1050', description: 'Headwall to suit 1050mmØ pipe', unit: 'Nr', defaultQuant: null },
  { id: 'hw_1200', description: 'Headwall to suit 1200mmØ pipe', unit: 'Nr', defaultQuant: null },
  { id: 'hw_civilise', description: 'Civilise existing ditchcourse immediately adjacent outfall headwall', unit: 'Nr', defaultQuant: null },
  { id: 'hw_riprap', description: 'Rip Rap', unit: 'm2', defaultQuant: null },
  { id: 'hw_breakout', description: 'Break out exiting headwall', unit: 'Nr', defaultQuant: null },
];
